import { put, call, take, fork } from 'redux-saga/effects'
import { teamsMemberListService } from '../../api/teams'
import { teamsMemberListSuccess } from 'src/reducers/teams/action'
import { TEAMS_MEMBER_LIST } from 'src/reducers/teams/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* teamsMemberListFlow(payload) {
  try {
    const { query, id, callback } = payload

    const response = yield call(teamsMemberListService, query, id)

    yield put(teamsMemberListSuccess(response.data))
    callback(response.data)
    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* teamsMemberListWatcher() {
  while (true) {
    const action = yield take(TEAMS_MEMBER_LIST)
    const { payload } = action

    yield fork(generalSaga, teamsMemberListFlow, payload)
  }
}
